import { makeStyles } from '@mui/styles'
const useStyleUpdateOrganization = makeStyles(() => ({
  backgroundBox: {
    width: '100%'
  },
  mainBox: {
    marginLeft: '5%',
    width: '90%',
    marginTop: '2%'
  },
  editTypography: {
    mt: 2,
    mb: 1,
    fontWeight: 'bold'
  },
  instructionsTypography: {
    mt: 2,
    mb: 1,
    color: '#2C3532',
    marginTop: '2%',
    marginBottom: '2%'
  },
  fieldsTypography: {
    mt: 2,
    mb: 1,
    fontSize: 14,
    marginTop: '2%',
    marginBottom: '2%'
  },
  textFields: {
    width: '70%'
  },
  formControl: {
    m: 1,
    minWidth: 120,
    width: '70%'
  },
  boxButton: {
    position: 'absolute',
    width: '95%',
    marginLeft: '5%',
    bottom: 20,
    display: 'flex'
  },
  editButton: {
    width: 90,
    height: 35,
    backgroundColor: '#1C846F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  editButtonTypography: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16
  },
  cancelButton: {
    width: 90,
    height: 35,
    marginLeft: 10,
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cancelButtonTypography: {
    color: '#262626',
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: '#1BF57F'
    }
  }
}))

export default useStyleUpdateOrganization
